import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import c from 'classnames';
import IconWrap from '../IconWrap';
import s from '../Animated.scss';
const BirthdayCakeAnimated = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        id: "assets",
        xmlSpace: "preserve"
    }, props), {
        width: "0",
        height: "0",
        viewBox: "0 0 32 32"
    }), /*#__PURE__*/ React.createElement("path", {
        className: c(s['anim'], s['anim-hue-rotate'], s['anim-duration-2s']),
        d: "M17.056,8.815C18.112,7.4 17.056,6.087 16.244,5.076C16.081,4.975 15.919,4.975 15.756,5.076C14.944,6.087 13.888,7.4 14.944,8.815C15.594,9.624 16.488,9.523 17.056,8.815ZM15,11L17,11L17,14L23.227,14C24.25,14 25,14.783 25,15.875L25,16.473C24.386,16.628 24.046,16.862 23.568,17.33C22.614,18.266 21.796,18.266 20.841,17.33C19.682,16.161 18.523,16.161 17.364,17.33C16.409,18.266 15.591,18.266 14.636,17.33C13.477,16.161 12.318,16.161 11.159,17.33C10.273,18.266 9.386,18.266 8.432,17.33C7.955,16.862 7.682,16.628 7,16.473L7,15.875C7,14.783 7.818,14 8.841,14L15,14L15,11ZM11.568,19.26C10.409,20.597 9.25,20.597 8.091,19.26L8.015,19.177C7.662,18.792 7.51,18.625 7,18.458L7,23C7,23.552 7.448,24 8,24L24,24C24.552,24 25,23.552 25,23L25,18.458C24.523,18.637 24.318,18.815 23.909,19.26C22.75,20.597 21.659,20.597 20.5,19.26C19.546,18.191 18.659,18.191 17.773,19.26C16.614,20.597 15.455,20.597 14.296,19.26C13.341,18.191 12.523,18.191 11.568,19.26Z",
        style: {
            fill: 'rgb(217,217,217)'
        }
    }), /*#__PURE__*/ React.createElement("path", {
        className: c(s['anim'], s['anim-scale']),
        d: "M29.933,21.65C27.767,21.289 27.767,18.4 27.767,18.4C27.767,18.4 27.767,21.289 25.6,21.65C27.767,22.011 27.767,24.9 27.767,24.9C27.767,24.9 27.767,22.011 29.933,21.65Z",
        style: {
            transformOrigin: '85% 70%',
            fill: 'rgb(217,217,217)'
        }
    }), /*#__PURE__*/ React.createElement("path", {
        className: c(s['anim'], s['anim-scale'], s['anim-delay-quarter']),
        d: "M5,8.7C5,8.7 5,12.7 8,13.2C5,13.7 5,17.7 5,17.7C5,17.7 5,13.7 2,13.2C5,12.7 5,8.7 5,8.7Z",
        style: {
            transformOrigin: '15% 39%',
            fill: 'rgb(217,217,217)'
        }
    })));
BirthdayCakeAnimated.displayName = 'BirthdayCakeAnimated';
export default BirthdayCakeAnimated;
